import { render, staticRenderFns } from "./TextAxis.vue?vue&type=template&id=461fb393&"
import script from "./TextAxis.vue?vue&type=script&lang=js&"
export * from "./TextAxis.vue?vue&type=script&lang=js&"
import style0 from "./TextAxis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextAxis.vue"
export default component.exports